<template>
  <div v-if="isVisible">
    <b-modal no-close-on-backdrop scrollable size="lg" @hide="onCloseModal" @shown="onOpenedModal" ref="order-form-modal" title="Add Order">
      <div v-show="formState === 'loading'">
        <p style="margin-bottom: 0px; text-align: center;">Loading data...</p>
      </div>
      <div v-show="formState === 'ready'">
        <b-form>
          <div class="form-row">
            <div class="form-group col-md-12">
              <label>Delivery Date</label>
              <b-form-input
                name="delivery_date"
                v-validate="'required'"
                :disabled="true"
                :class="{'is-invalid': errors.has('delivery_date')}"
                v-model="form.delivery_date"
                class="mb-2"
                type="text" placeholder="Delivery Date"></b-form-input>
              <b-form-feedback>{{ errors.first('delivery_date') }}</b-form-feedback>
            </div>
            <div class="form-group col-md-12">
              <label>Number</label>
              <b-form-input
                name="number"
                v-validate="'required'"
                :class="{'is-invalid': errors.has('number')}"
                v-model="form.number"
                class="mb-2"
                type="text" placeholder="Number"></b-form-input>
              <b-form-feedback>{{ errors.first('number') }}</b-form-feedback>
            </div>
            <div class="form-group col-md-12">
              <label>Customer</label>
              <multiselect
                name="customer"
                v-validate="'required'"
                :class="{'multiselect-danger': errors.has('customer')}"
                v-model="form.selectedCustomer"
                :options="customersData"
                label="name"
                track-by="id"
                placeholder="Select customer" class="mb-2"/>
            </div>
            <div class="form-group col-md-12">
              <label>Destination</label>
              <multiselect
                name="destination"
                v-validate="'required'"
                :class="{'multiselect-danger': errors.has('destination')}"
                v-model="form.selectedDestination"
                :options="destinationsData"
                label="name"
                track-by="id"
                placeholder="Select destination" class="mb-2"/>
            </div>
            <div class="form-group col-md-12">
              <label>Vehicle</label>
              <multiselect
                  name="vehicle"
                  v-model="form.selectedShipment"
                  :options="vehicleShipments"
                  label="reg_no"
                  track-by="id"
                  placeholder="Select vehicle" class="mb-2"/>
            </div>
            <div class="form-group col-md-12">
              <label>Quantity</label>
              <b-form-input
                name="qty"
                v-validate="'required'"
                :class="{'is-invalid': errors.has('qty')}"
                v-model="form.quantity"
                class="mb-2"
                type="text" placeholder="Quantity"></b-form-input>
              <b-form-feedback>{{ errors.first('qty') }}</b-form-feedback>
            </div>
            <div class="form-group col-md-12">
              <label>Volume</label>
              <b-form-input
                name="volume"
                v-validate="'required'"
                :class="{'is-invalid': errors.has('volume')}"
                v-model="form.volume"
                class="mb-2"
                type="text" placeholder="Volume"></b-form-input>
              <b-form-feedback>{{ errors.first('volume') }}</b-form-feedback>
            </div>
            <div class="form-group col-md-12">
              <label>Weight</label>
              <b-form-input
                name="weight"
                v-validate="'required'"
                :class="{'is-invalid': errors.has('weight')}"
                v-model="form.weight"
                class="mb-2"
                type="text" placeholder="Weight"></b-form-input>
              <b-form-feedback>{{ errors.first('weight') }}</b-form-feedback>
            </div>
          </div>
        </b-form>
      </div>
      <template #modal-footer>
        <b-button class="mr-2 pull-right" variant="outline-danger" @click="hideModal">Close</b-button>
        <b-button class="mr-2 pull-right" variant="primary" @click="onSubmit()">{{ textButton }}</b-button>
      </template>
    </b-modal>
  </div>
</template>

<script>
import { get, head } from 'lodash';
import { format } from 'date-fns';
import Multiselect from 'vue-multiselect';

export default {
  name: 'OrderInputForm',
  components: {
    Multiselect,
  },
  props: {
    isVisible: {
      type: Boolean,
      default: false,
    },
    formState: {
      type: String,
      default: 'loading',
    },
    customersData: {
      type: Array,
      default: [],
    },
    shipmentsData: {
      type: Array,
      default: [],
    },
    deliveryDate: {
      type: Date,
      default: '',
    },
  },
  mounted() {

  },
  data() {
    return {
      destinationsData: [],
      vehicleShipments: [],
      form: {
        selectedCustomer: null,
        selectedShipment: null,
        selectedDestination: null,
        quantity: '',
        volume: '',
        weight: '',
        number: '',
        delivery_date: null,
      },
      textButton: 'Submit',
    };
  },
  computed: {
    isSystemAdmin() {
      const { userData } = this.$store.getters;
      return userData.type === 'SYSTEM_ADMIN';
    },
    selectedCustomerData() {
      return this.form.selectedCustomer;
    },
    myCompany() {
      const { userData } = this.$store.getters;
      return userData.company_id;
    },
  },
  watch: {
    isVisible(show) {
      if (show) {
        setTimeout(() => {
          this.$refs['order-form-modal'].show();
        }, 5e2);
      }
    },
    formState(state) {
      if (state === 'ready') {
        this.vehicleShipments = this.shipmentsData.map(shipment => ({
          id: get(shipment, 'id'),
          reg_no: get(shipment, 'vehicle.reg_no') || '-',
        }));
        this.form.delivery_date = format(this.deliveryDate, 'DD MMM YYYY');
      }
    },
    selectedCustomerData(customer) {
      this.form.selectedDestination = null;
      const { id } = customer;
      this.getLocationsByCompanyId(id).then((locations) => {
        const countLocations = locations.length;
        if (countLocations) {
          this.destinationsData = locations;
          if (countLocations === 1) {
            this.form.selectedDestination = head(locations);
          }
        }
      });
    },
  },
  methods: {
    onOpenedModal() {
      this.$emit('on-opened-modal');
    },
    onCloseModal() {
      this.$emit('on-closed-modal');
    },
    hideModal() {
      this.form.selectedDestination = null;
      this.form.selectedCustomer = null;
      this.form.selectedShipment = null;
      this.form.quantity = '';
      this.form.weight = '';
      this.form.volume = '';
      this.form.number = '';
      this.$refs['order-form-modal'].hide();
    },
    onSubmit() {
      this.validate().then((valid) => {
        if (valid) {
          const { form } = this;
          const shipmentId = get(form, 'selectedShipment.id') || null;
          const payloads = {
            number: get(form, 'number'),
            company: { id: this.myCompany },
            shipment: get(form, 'selectedShipment'),
            customer: get(form, 'selectedCustomer'),
            destination: get(form, 'selectedDestination'),
            delivery_date: format(this.deliveryDate, 'YYYY-MM-DD'),
            metadata: {
              total_gross_volume: get(form, 'volume'),
              total_gross_weight: get(form, 'weight'),
              total_quantity_unit: get(form, 'quantity'),
            },
          };
          const onSuccess = () => {
            this.textButton = 'Success';
            setTimeout(() => {
              this.$emit('on-submited-data');
              this.hideModal();
              this.textButton = 'Submit';
            }, 2e2);
          };
          this.textButton = 'Loading...';
          this.createOrder(payloads).then((order) => {
            if (order) {
              if (shipmentId) {
                this.addShipmentOrder(shipmentId, order.id).then(() => {
                  onSuccess();
                });
              } else {
                onSuccess();
              }
            }
          });
        }
      });
    },
    validate() {
      return this.$validator.validateAll();
    },
    getLocationsByCompanyId(id) {
      return this.$store.dispatch('shipment_md/locations/GET_LOCATIONS_BY_COMPANYID', { company_id: id });
    },
    createOrder(payloads) {
      return this.$store.dispatch('shipment_md/orders/CREATE_DATA', payloads);
    },
    addShipmentOrder(shipmentId, orderId) {
      return this.$store.dispatch('shipment_md/shipments/ADD_ORDER', {
        shipment_id: shipmentId,
        order_id: orderId,
      });
    },
  },
};
</script>

<style lang="sass">
  .modal-fullscreen
    max-width: 100% !important;
    margin: 0;
    top: 0;
    bottom: 0;
    left: 0;
    right: 0;
    height: 100vh;
    display: flex;
    position: fixed;
    z-index: 100000;
    max-height: 100% !important;

  .content-fullscreen
    max-height: 100% !important;
</style>



// WEBPACK FOOTER //
// src/components/AddOrderForm.vue